import { inject, Injectable } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { AlertService } from '../components/alert/alert.service';
import { ENV_TOKEN } from '../../app-module.token';
import { WindowFirma, WindowFirmaResponse } from './window-firma';
import { ElectronicDemandService } from '../../components/demanda/electronicDemand.service';
import { v4 as uuidv4 } from 'uuid';
import { Documents } from '../class/archivo.inteface';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FirmadorService {
  private authService = inject(AuthService);
  private constService: any;
  readonly environment = inject(ENV_TOKEN);
  private readonly windowFirma = new WindowFirma();
  private alertService = inject(AlertService);
  private _service: ElectronicDemandService = inject(ElectronicDemandService);
  constructor(){
    this.constService = this.environment;
  }

  public async openWindowFirma(uuid: string, fileType: number, AcceptDocx=false): Promise<Documents[]> {
    if (uuid === "0") {
      uuid = uuidv4();
    }

    const paramsFilePath = {
      userName: this.authService.getUserName(),
      idUser: this.authService.getIdUser(),
      idOrganismo: this.authService.getIdOrgan(),
      IdSystem: 1,
      IdPantalla: 0,
      IdTransaction: uuid,
      tipoArchivo: fileType
    };
    
    const payload = {
      ...this.environment.signData,
      endPointFilePath: "unc.api.filepath/api/Interconexion/Sign",
      tokenFilePath: '',
      paramsFilePath: JSON.stringify(paramsFilePath),
      idOperacion: uuid,
      idProceso: uuid,
      usuarioSistemaCliente: this.authService.getUserName(),
      sistemaCliente: this.environment.apiBaseUrl
    };
    if(AcceptDocx){
      payload['accept'] = '.pdf, .docx';
    }
    else{
      payload['accept'] = '.pdf';
    }
    const signOrigin = new URL(this.environment.apiBaseUrlSite).origin;
    const siteFirma = this.environment.siteFirma;
    let signSrc: string;
    if (!siteFirma || siteFirma === '/') {
       signSrc = `${signOrigin}/sign`;
    }
    else{
       signSrc = `${signOrigin}/${siteFirma}/sign`;
    }

    try {
      const response: WindowFirmaResponse = await this.windowFirma.open({
        payload,
        src: signSrc,
        domain: signOrigin,
        blockerMessage: 'Procesando firma...',
        showForceCloseButton: false,
        forceCloseButtonText: 'Close 🍕',
        useBlocker: true,
        windowStyle: { width: 960, height: 640, center: true, features: { resizable: 'yes', scrollbars: 'yes' } }
      });

      if (response.payload.success) {
        const payload = {
          guid: uuid,
          nombreSesion: this.authService.getUserName(),
          documentos: response.payload.filesSign,
        };
        const statusUpdated = await this.updateStatusSign(payload);
        return statusUpdated ? await this.uploadFileList(uuid) : [];
      } else {
        this.alertService.error(response.payload.mensaje, { keepAfterRouteChange: false });
        return this.uploadFileList(uuid);
      }
    } catch (error) {
      this.alertService.error(`Error: ${String(error)}`, { keepAfterRouteChange: false });
      return this.uploadFileList(uuid);
    }
  }

  private async updateStatusSign(payload: any): Promise<boolean> {
    try {
      const response: any = await firstValueFrom(this._service.updateStatusSign(payload));
      const isSuccess = (response?.success ?? response?.succcess) === true;
      const message = response?.message ?? 'No fue posible actualizar el estatus de firma.';

      if (!isSuccess) {
        this.alertService.error(message, { keepAfterRouteChange: false });
      }

      return isSuccess;
    } catch (httpError: any) {
      const message = httpError?.error?.message ?? httpError?.message ?? 'Ocurrió un error al actualizar el estatus de firma.';
      this.alertService.error(message, { keepAfterRouteChange: false });
      return false;
    }
  }

  uploadFileList(uuid: string): Promise<Documents[]> {
    return this.GetDocumentosPantalla(uuid);
  }

  public GetDocumentosPantalla(uuid: string): Promise<Documents[]> {
    return new Promise((resolve) => {
      this._service.getDocumentosPantallaGuid(uuid)
        .subscribe((response: Documents[]) => {
          if (response?.length > 0) {
            resolve(response);
          }
          else {
            resolve([]);
          }
        }, (error: any) => {
          this.alertService.error(error.message, { keepAfterRouteChange: false });
          resolve([]);
        });
    });
  }
}
